import React from 'react';
import SmiWidget from '../../components/smiWidgets/SmiWidget';

export const Feed = ({ isDesktop, isFull, widgetBlocks }) => {
    const blocks = Array.isArray(widgetBlocks) ? widgetBlocks : [widgetBlocks];

    return (
            <SmiWidget
                isDesktop={isDesktop}
                isFull={isFull}
                blockIds={widgetBlocks}
            />
    );
}
